// The intro: a self-contained three.js page living in public/teaser/ (copied
// from cloudish-explore). It never autoplays, and its own start gate is the
// branded poster. The frame is always mounted so that the play press happens
// inside it. That is the only way sound starts reliably: mobile Safari doesn't
// carry a gesture from this document into a frame mounted after it, which
// Chrome does. Mounted, it's only the poster: the film itself (three.js, the
// textures, every scene built and warmed up) and its soundtrack load once a
// mouse rests on the poster, it takes keyboard focus, or it's pressed, with
// the play ring filling as it loads (the gate script in public/teaser/).
// loading="lazy" keeps even the poster off a page opened further down.
//
// Behind the stage sits a backlight the hero lights while the intro plays,
// in the picture's own colors (IntroAmbience.tsx); otherwise it's dark.
//
// While most of the stage is on screen and the page has been scrolled, <html>
// gets .teaser-in-view, which fades the sticky nav out on phones held
// sideways (styles.css) to give the film the room. Not before scrolling: the intro sits in the hero,
// often fully on screen on arrival, and a page shouldn't open without its nav.

import { useEffect, useRef } from 'react';

const INTRO_SRC = '/teaser/index.html';

export function TeaserPlayer() {
  const stageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const stage = stageRef.current;
    if (!stage || typeof IntersectionObserver === 'undefined') return;   // jsdom, in the tests
    const root = document.documentElement;
    let inView = false;
    const sync = () => root.classList.toggle('teaser-in-view', inView && scrollY > 24);
    const observer = new IntersectionObserver(
      ([entry]) => {
        inView = entry.isIntersecting;
        sync();
      },
      { threshold: 0.6 },
    );
    observer.observe(stage);
    addEventListener('scroll', sync, { passive: true });
    return () => {
      observer.disconnect();
      removeEventListener('scroll', sync);
      root.classList.remove('teaser-in-view');
    };
  }, []);

  return (
    <div className="teaser" id="intro">
      <div className="teaser-backlight" aria-hidden="true" />
      <div className="teaser-stage" ref={stageRef}>
        <iframe
          className="teaser-frame"
          src={INTRO_SRC}
          title="Cloudish intro"
          loading="lazy"
          allow="autoplay; fullscreen"
          allowFullScreen
        />
      </div>
    </div>
  );
}
